/* @flow */

export default {
  root: {
    width: 15,
    height: 15,
  },
};
